import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "bin",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "global-bin" */ "./components"),
      import(
        /* webpackChunkName: "global-bin" */ "AdminSettings/routes/Bin/modules/BinModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;
      injectReducer(store, { key: "bin", reducer });
      return component;
    })
  ),
  childRoutes: [],
});
